export { useMppAttestationDataByTin } from './useMppAttestationDataByTin';
